import { tabsAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const config = createMultiStyleConfigHelpers(tabsAnatomy.keys);

const lineVariant = config.definePartsStyle({
  tablist: {
    color: 'whiteAlpha.600',
    borderBottomColor: 'whiteAlpha.400',
    _light: {
      color: 'gray.300',
      borderBottomColor: 'blackAlpha.200',
    },
  },
  tab: {
    _selected: {
      borderBottomColor: 'texas.sand.100 !important',
      color: 'white',
    },
    _light: {
      color: 'gray.300',
      _selected: {
        color: 'texas.bg.900',
        borderBottomColor: 'texas.burntSienna.500 !important',
      },
    },
  },
});

const stepVariant = config.definePartsStyle({
  tablist: {
    bg: 'gray.800',
    _light: { bg: 'gray.50' },
  },
  tab: {
    width: 'auto',
    height: '2rem',
    ml: '-16px',
    position: 'relative',
    bg: 'gray.800',
    _selected: {
      bg: 'gray.600',
      color: 'white',
      _light: {
        color: 'texas.bg.900',
      },
    },
  },
});

const buttonVariant = config.definePartsStyle({
  tab: {
    fontFamily: 'Barlow',
    fontWeight: 'semibold',
    bg: 'transparent',
    borderRadius: '40px',
    border: '2px solid',
    borderColor: 'whiteAlpha.200',
    color: 'gray.300',
    mr: 2,
    _light: { color: 'gray.500', borderColor: 'blackAlpha.200' },
    _hover: {
      color: 'gray.100',
      borderColor: 'whiteAlpha.400',
      _light: {
        color: 'gray.700',
        borderColor: 'blackAlpha.400',
      },
    },
    _selected: {
      backgroundColor: 'texas.sand.100',
      color: 'white',
      fontWeight: 'bold',
      _light: {
        backgroundColor: 'texas.burntSienna.500',
        color: 'white',
      },
    },
  },
  tabpanel: {
    py: '16px',
    px: 0,
  },
});

const compositionVariant = config.definePartsStyle({
  tab: {
    color: 'gray.200',
    borderRadius: 'md',
    textAlign: 'left',
    border: '1px solid',
    borderColor: 'texas.bg.900',
    _selected: {
      background: 'texas.sand.50',
      color: 'texas.bg.950',
    },
    _light: {
      _disabled: {
        opacity: 0.8,
      },
      color: 'gray.400',
      borderColor: 'gray.100',
      _selected: {
        bg: 'texas.burntSienna.500',
        color: 'white',
      },
    },
  },
});

const supplierVersions = config.definePartsStyle({
  tab: {
    color: 'gray.200',
    borderRadius: 'md',
    background: 'transparent',
    border: '1px solid',
    borderColor: 'texas.bg.800',
    _selected: {
      background: 'gray.700',
      color: 'white',
    },
    _light: {
      borderColor: 'gray.100',
      color: 'gray.500',
      _selected: {
        bg: 'gray.50',
        color: 'gray.700',
      },
    },
  },
  tabpanel: {
    px: 0,
  },
});

const unstyledWithOpacity = config.definePartsStyle({
  tab: {
    opacity: '0.7',
    _selected: { opacity: 1 },
  },
});

const entityLifecycle = config.definePartsStyle({
  root: { width: 'full', minWidth: 0 },
  tablist: {
    alignItems: 'flex-end',
    borderBottom: '1px solid',
    borderColor: 'inquiryOverview.border',
    gap: 7,
    minHeight: '50px',
    marginBottom: 5,
    overflowX: 'auto',
  },
  tab: {
    padding: 0,
    flexShrink: 0,
    borderBottom: '3px solid',
    borderColor: 'transparent',
    color: 'inquiryOverview.mutedText',
    fontFamily: 'barlow',
    fontSize: '15px',
    fontWeight: 'medium',
    gap: 2,
    height: '50px',
    '& [data-lifecycle-count]': {
      background: 'inquiryOverview.badgeBackground',
      color: 'inquiryOverview.mutedText',
      minWidth: 6,
      height: 6,
      paddingX: 1.5,
      borderRadius: 'full',
      fontFamily: 'instrumentSans',
      fontSize: '12px',
      fontWeight: 'normal',
      lineHeight: 6,
    },
    _selected: {
      borderColor: 'texas.burntSienna.500',
      color: 'inquiryOverview.text',
      fontWeight: 'semibold',
      '& [data-lifecycle-count]': {
        background: 'inquiryOverview.activeBadgeBackground',
        color: 'inquiryOverview.activeBadgeText',
      },
    },
  },
  tabpanel: { padding: 0, paddingTop: 5 },
});

const variants = {
  'entity-lifecycle': entityLifecycle,
  line: lineVariant,
  step: stepVariant,
  button: buttonVariant,
  composition: compositionVariant,
  'supplier-versions': supplierVersions,
  'unstyled-opacity': unstyledWithOpacity,
};

export default config.defineMultiStyleConfig({
  defaultProps: { variant: 'line' },
  variants,
});
